import { gql } from 'apollo-boost';


export const fragments = {

    AUDIT_RECORDS: {
        QUERY_RETURN:        `auditEntries{ id accountId timestampUtc auditType auditData entityId entityType }`,
        SOURCE_QUERY_RETURN: `id accountId timestampUtc auditType auditData entityId entityType entityLabel`,
    }
};

export const queries = {

    GET_AUDIT_RECORDS: ( returnQueryString = fragments.AUDIT_RECORDS.SOURCE_QUERY_RETURN ) => gql`
        query getAuditRecords( $order:[AuditEntrySortInput!], $where:AuditEntryFilterInput ){
            auditEntries( order: $order, where: $where) {
                ${ returnQueryString }
            }
        }`,
};

export const mutations = {

    TRIGGER_EXTERNAL_EVENT: () => gql`
        query triggerExternalEvent( $input:ExternalEventTriggerCommandInput! ){
            triggerExternalEvent( input: $input )
        }`,
};

export const SystemRecordQueries = {
    fragments,
    queries,
    mutations,
};
